// SPDX-License-Identifier: AGPL-3.0-or-later

/**
 * KONVO: the short file type shown after the size on a file card ("4.3 MB · PowerPoint").
 * Office formats get their app name, everything else its extension in capitals, so no
 * translation is needed. Empty when the file has no extension.
 */
const NAMED_TYPES: Record<string, string> = {
	ppt: 'PowerPoint',
	pptx: 'PowerPoint',
	doc: 'Word',
	docx: 'Word',
	xls: 'Excel',
	xlsx: 'Excel',
	pdf: 'PDF',
};

export function fileTypeLabel(extension: string): string {
	const ext = extension.trim().replace(/^\./, '').toLowerCase();
	if (!ext || ext.length > 8 || !/^[a-z0-9]+$/.test(ext)) return '';
	return NAMED_TYPES[ext] ?? ext.toUpperCase();
}
